import { styled } from "@mui/material/styles";

export const Tags = styled("g")(({ theme }) => ({
  "& > g > line": {
    strokeWidth: "1px",
    strokeDasharray: "4, 4",
    stroke: theme.vars.palette.text.secondary,
  },
  "& > g > text": {
    fill: theme.vars.palette.text.secondary,
    fontSize: 12,
    textAnchor: "middle",
  },
  "& > g > circle": {
    stroke: theme.vars.palette.divider,
    fill: theme.vars.palette.texts.neutral.decoration,
  },
  "& > g > rect": {
    fill: theme.vars.palette.backgrounds.static.soft,
  },
}));
